<template>
    <div v-if="data.driver">
        <b-row sm="10">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ชื่อ</label>
            </b-col>
            <b-col sm="5" class="col-sm-5">
                <input class="form-control"
                       v-model="data.driver.name" disabled/>
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ทะเบียนรถ</label>
            </b-col>
            <b-col sm="5" class="col-sm-5">
                <input class="form-control"
                       v-model="data.driver.license_plate" disabled/>
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ประเภทรถ</label>
            </b-col>
            <b-col sm="5" class="col-sm-5">
                <input class="form-control"
                       v-model="data.driver.transport_type.name" disabled/>
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ยอดเงิน</label>
            </b-col>
            <b-col sm="5" class="col-sm-5">
                <input class="form-control"
                       v-model="data.amount" disabled/>
            </b-col>
        </b-row>
        <br>
        <div class="text-center">
            <b-form-group>
                <b-form-radio-group
                        :options="options"
                        v-model="data.status"
                        name="radioInline">
                </b-form-radio-group>
            </b-form-group>
        </div>
        <br>
        <div class="col text-center">
            <button @click="submitData"
                    type="button"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก</button>&nbsp&nbsp
            <button @click="cancelData"
                    type="button"
                    class="btn btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        name: "driver-bonus-status",
        data(){
            return {
                options: [
                    { text: 'รอชำระ', value: 1 },
                    { text: 'ชำระเรียบร้อย', value: 2 }
                ]
            }
        },
        created(){

        },
        computed:{
            ...mapState({
                data :state=>{
                    return state.DriverBonus.bonusData;
                }
            })
        },
        methods:{
            submitData(){
                this.$emit('submit',this.data);
            },
            cancelData(){
                this.$emit('submit',0);
            }
        }
    }
</script>

<style scoped>

</style>